import React from 'react';
import { urls } from '../../config';
import './step3.less';
import {
    createStepThreeCreateNew,
    createStepThreeFacebook,
    createStepThreeInstagram,
    createStepThreeRevenue,
    createStepThreeYoutube,
    enterCreateStepThree
} from '../../ga-config';

export default function Step3(props) {
    GA.add(enterCreateStepThree);
    const {
        onCreateMore = () => {
            console.log('onCreateMore');
        },
        onCheckRevenue = () => {
            console.log('onCheckRevenue');
        }
    } = props;

    const createMore = () => {
        GA.add(createStepThreeCreateNew);
        onCreateMore();
    };

    const revenueClick = () => {
        GA.add(createStepThreeRevenue);
        onCheckRevenue();
    };

    const goToUrl = url => {
        return function () {
            switch (url) {
                case urls.youtube:
                    GA.add(createStepThreeYoutube);
                    break;
                case urls.instagram:
                    GA.add(createStepThreeInstagram);
                    break;
                case urls.facebook:
                    GA.add(createStepThreeFacebook);
                    break;
                default:
                    break;
            }
            location.href = url;
        };
    };

    return (
        <div className="ci-step3">
            <div className="ci3-vendor">
                <div id="ci3-youtube" onClick={goToUrl(urls.youtube)}>Youtube</div>
                <div id="ci3-instagram" onClick={goToUrl(urls.instagram)}>Instagram</div>
                <div id="ci3-facebook" onClick={goToUrl(urls.facebook)}>Facebook</div>
            </div>
            <div className="ci3-buttons text-center">
                <button type="button" className="btn-cus btn-lg" onClick={createMore}>
                    {UG.lang.template('Create more dashboards')}
                </button>
                <button type="button" className="btn-cus btn-lg" onClick={revenueClick}>
                    {UG.lang.template('Check revenue')}
                </button>
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./js/host/gift/step3.js